import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'

export default class IsNewToMedicareStreamlinedEnabledNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { flag } = FeatureFlags.use()

    return this.yesNo(flag<boolean>('new-to-medicare-flow-streamlined').value)
  }
}
